import React from "react";
import { Box, Paper, Grid } from "@mui/material";
import { ICompanyProfileItem } from "src/common/typings/companyProfile";
import CommonButtonDefault from "src/components/CommonButton/CommonButtonDefault";
import { CardItem } from "./CardItem";

interface Props {
  InfoData: ICompanyProfileItem | any;
  editCompany: () => void;
}

export const Card = ({ InfoData, editCompany }: Props) => {
  const {
    company,
    address,
    contactEmail,
    contactPerson,
    fax,
    mailingAddress,
    mailingCompany,
    phone,
    city,
    zip,
    state,
    mailingCity,
    mailingState,
    mailingZip,
    checkAddress,
    checkCity,
    checkState,
    checkZip,
    checkCompany,
    isServiceFee,
    serviceFee,
    vendorNum,
  } = InfoData;
  const effectiveMailingAddress = mailingAddress ?? checkAddress;
  const effectiveMailingCompany = mailingCompany ?? checkCompany;
  const effectiveMailingCity = mailingCity ?? checkCity;
  const effectiveMailingState = mailingState ?? checkState;
  const effectiveMailingZip = mailingZip ?? checkZip;
  const renderCombineValie = (per: boolean) => {
    const combineAddress: any[] = [];
    if (per) {
      if (address) {
        combineAddress.push(address);
      }
      if (city) {
        if (address) {
          combineAddress.push(` ${city}`);
        } else {
          combineAddress.push(city);
        }
      }
      if (state) {
        if (address || city) {
          combineAddress.push(` ${state}`);
        } else {
          combineAddress.push(state);
        }
      }
      if (zip) {
        if (address || city || state) {
          combineAddress.push(` ${zip}`);
        } else {
          combineAddress.push(zip);
        }
      }
    } else {
      if (effectiveMailingAddress) {
        combineAddress.push(effectiveMailingAddress);
      }
      if (effectiveMailingCity) {
        if (effectiveMailingAddress) {
          combineAddress.push(` ${effectiveMailingCity}`);
        } else {
          combineAddress.push(effectiveMailingCity);
        }
      }
      if (effectiveMailingState) {
        if (effectiveMailingAddress || effectiveMailingCity) {
          combineAddress.push(` ${effectiveMailingState}`);
        } else {
          combineAddress.push(effectiveMailingState);
        }
      }
      if (effectiveMailingZip) {
        if (effectiveMailingAddress || effectiveMailingCity || effectiveMailingState) {
          combineAddress.push(` ${effectiveMailingZip}`);
        } else {
          combineAddress.push(effectiveMailingZip);
        }
      }
    }
    if (combineAddress.length) {
      return combineAddress.toString();
    }
    return "";
  };
  return (
    <>
      <Paper elevation={1} square>
        <Box p={2} mb={3}>
          <Grid container direction="row">
            <Grid item container direction="row" xs={12} md={10}>
              <CardItem field="Company" value={company} />
              <CardItem field="Vendor ID" value={vendorNum ?? ""} />
              <CardItem field="Contact Person" value={contactPerson} />
              <CardItem field="Contact Email" value={contactEmail} truncateWithTooltip />
              <CardItem field="Phone #" value={phone} />
              <CardItem field="Fax" value={fax} />
              <CardItem
                field="Check Address"
                value={renderCombineValie(false)}
                truncateWithTooltip
              />
              <CardItem field="Check Company" value={effectiveMailingCompany} />
              <CardItem
                field="Address"
                value={renderCombineValie(true)}
                truncateWithTooltip
              />
              {isServiceFee && (
                <CardItem field="Service Fee" value={`${serviceFee || "0.00"}%`} />
              )}
            </Grid>
            <Grid item xs={12} md={2}>
              <Box mb={2} textAlign="right" display="flex" flexDirection="column">
                <Box component="span">
                  <CommonButtonDefault isGreen onClick={() => editCompany()}>
                    Edit
                  </CommonButtonDefault>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </>
  );
};
